/** 日期字符串截取 yyyy-MM-dd */

export function normalizeDateOnly(val) {

  if (val == null || val === '') return null;

  var s = String(val).trim();

  return s.length >= 10 ? s.substring(0, 10) : s;

}



/**

 * 日语 addorupdate_base 提交体：不传 createTime/inputTime，避免模型绑定污染添加时间。

 * 仅在有有效日期时传 jpInputTime。仅用于日语板块页面。

 */

export function buildJapSubmitPayload(form) {

  var info = Object.assign({}, form);

  delete info.createTime;

  delete info.inputTime;

  // 日语状态走 japState/JpStatus，避免列表别名字段 state 污染主表 State
  delete info.state;
  delete info.State;

  var d = normalizeDateOnly(info.jpInputTime);

  if (d) {

    info.jpInputTime = d;

  } else {

    delete info.jpInputTime;

  }

  var quit = normalizeDateOnly(info.quitTime || info.QuitTime);

  if (quit) {

    info.quitTime = quit;

    info.QuitTime = quit;

  }

  return info;

}



/**

 * 统一录入提交：留学/鸣野仍用 inputTime；仅勾选日语时额外传 jpInputTime，互不影响。

 */

export function prepareUnifiedSubmitTime(info) {

  if (info.inputTime) {

    info.inputTime = normalizeDateOnly(info.inputTime);

  }

  if (info.isJap && info.inputTime) {

    info.jpInputTime = info.inputTime;

    info.JpInputTime = info.inputTime;

  }

  return info;

}



/** @deprecated 使用 prepareUnifiedSubmitTime */

export function attachUnifiedJpInputTime(info) {

  return prepareUnifiedSubmitTime(info);

}


